import {DEFAULT_ANIMATION_LOOPS} from 'powtoon-document/consts'

export default function animatedItem(libraryItem) {
  const {animationLoops: loops} = libraryItem
  return {
    playbackSettings: {
      loopBehavior: loops === 0 ? 'none' : (loops === -1 ? 'endless' : 'counted'),
      numberOfLoops: (loops >= 1 && loops <= 99) ? loops : DEFAULT_ANIMATION_LOOPS
    }
  }
}
